module.exports = __webpack_public_path__ + "media/images/home/status_bar-7f689a51604af3aecbad12d116d128e4.svg";